import { useState } from "react";

export const EMPTY_BULK_SELECTION = { allFiltered: false, ids: [] };

export const buildBulkSelection = (state, setState, totals = 0) => {
  const { allFiltered, ids } = state;
  const count = allFiltered ? Math.max(totals - ids.length, 0) : ids.length;
  const allChecked = allFiltered && ids.length === 0 && totals > 0;

  return {
    allFiltered,
    count,
    allChecked,
    indeterminate: count > 0 && !allChecked,
    payload: allFiltered ? { all: true, exclude_ids: ids } : { ids },
    isSelected: (id) => (allFiltered ? !ids.includes(id) : ids.includes(id)),
    toggle: (id) =>
      setState((prev) => ({
        ...prev,
        ids: prev.ids.includes(id)
          ? prev.ids.filter((value) => value !== id)
          : [...prev.ids, id],
      })),
    toggleAll: (checked) => setState({ allFiltered: checked, ids: [] }),
    clear: () => setState(EMPTY_BULK_SELECTION),
  };
};

export default function useBulkSelection(totals = 0) {
  const [state, setState] = useState(EMPTY_BULK_SELECTION);
  return buildBulkSelection(state, setState, totals);
}
